import { useEffect, useState } from 'react';
// eslint-disable-next-line jira/restricted/use-debounce
import { useDebouncedCallback } from 'use-debounce';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useHelpPanel } from '../components/index.tsx';
import { HELP_PANEL_UI_STORAGE_KEY } from '../constants.tsx';

const DEBOUNCE_TIME = 1000;

export const RemoteStateUpdater = () => {
	// right-sidebar
	const [{ releaseNotesNotifications }] = useHelpPanel();
	const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] =
		useState(releaseNotesNotifications);

	const accountId = useAccountId();

	const [debouncedUpdateData] = useDebouncedCallback(async (newReleaseNotesNotifications) => {
		const remoteData = {
			helpPanel: { releaseNotesNotifications: newReleaseNotesNotifications },
		};

		if (accountId) {
			try {
				await setUserProperties(accountId, HELP_PANEL_UI_STORAGE_KEY, JSON.stringify(remoteData));
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (e: any) {
				fireErrorAnalytics({
					error: e,
					meta: {
						id: 'updateServerHelpPanelState',
						packageName: 'jiraHelpPanelServices',
						teamName: 'self-help-experiences',
					},
				});
			}
		}
	}, DEBOUNCE_TIME);

	useEffect(() => {
		if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
			// eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
			setReleaseNotesNotificationsTemp(releaseNotesNotifications);
			debouncedUpdateData(releaseNotesNotifications);
		}
	}, [debouncedUpdateData, releaseNotesNotifications, releaseNotesNotificationsTemp]);

	return null;
};
